/**
 * Sidebar
 */

// Scripts
$('.sticky-sidebar').sticky({ stopper: '.call-to-action' });



// WEBPACK FOOTER //
// ./assets/js/components/sidebar.js